export default __webpack_public_path__ + "static/media/classified.9677e3c4.JPG";